import React, { useEffect, useState } from "react";
import { cellRendererCheck, dateFormate, currencyFormat } from "utils/columns";
import useAxios from "hooks/useAxios";
import ReactStrapTable from "components/reactStrapTable";
const DispenseFees = ({
  reset,
  rowData
}) => {
  const [resultData, setResultData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const API = useAxios();
  useEffect(() => {
    fetchCustomDispensingFee();
    fetchFlatDispensingFee();
  }, [])
  useEffect(() => {
    fetchCustomDispensingFee();
    fetchFlatDispensingFee();
  }, [reset]);
  const fetchFlatDispensingFee = async () => {
    try {
      const result = await API.get(
        `GWConfig/Configuration/getFlatdispensingfee/${rowData.contractID}`,
        {
          hasDefaultURL: true,
        }
      );
      if (result) {
        setResultData(result.data);
      }
    } catch (error) {

      setLoading(false);
    }
  };
  const fetchCustomDispensingFee = async () => {
    try {
      const result = await API.get(
        `GWConfig/Configuration/getCustomDispensingfee/${rowData.contractID}`,
        {
          hasDefaultURL: true,
        }
      );
      if (result) {
        setTableData(result.data);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  let mainCol = [
    

    {
      dataField: "feeNameType",
      text: "Fee Name Type",
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      sort: false,
      width: 280,
      show: true,
      inputType: "text",
    },

    {
      dataField: "brandGenericFlg",
      text: "Tier",
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      sort: false,
      width: 280,
      show: true,
      inputType: "text",
    },
    {
      dataField: "feetype",
      text: "Fee Type",
      cellRenderer: (col) => "Flat",
      sort: false,
      width: 280,
      show: true,
      inputType: "text",
    },
    {
      dataField: "feevariable",
      text: "Fee Variable",
      cellRenderer: (col) => "Per Claim",
      sort: false,
      width: 280,
      show: true,
      inputType: "text",
    },
    {
      dataField: "flatValue",
      text: "Amount",
      sort: false,
      width: 140,
      show: true,
      inputType: "date",
      hideColFilter: true,
      cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
    },
    {
      dataField: "startDate",
      text: "Start Date",
      sort: false,
      width: 140,
      show: true,
      inputType: "date",
      hideColFilter: true,
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
    },
    {
      dataField: "endDate",
      text: "End Date",
      sort: false,
      width: 140,
      show: true,
      inputType: "date",
      hideColFilter: true,
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
    },
    {
      dataField: "comments",
      text: "Comments",
      sort: false,
      width: 140,
      show: true,
      inputType: "date",
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

  ]

  let maincol1 = [
    {
      dataField: "serial",
      text: "Serial",
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: 60,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "customdispensingfee",
      text: "Custom Dispensing Fee",
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      sort: false,
      width: 280,
      show: true,
      inputType: "text",
    },
    {
      dataField: "startDate",
      text: "Start Date",
      sort: false,
      width: 100,
      show: true,
      inputType: "date",
      hideColFilter: true,
      cellRenderer: (rowData) => dateFormate(rowData.startDate),
    },
    {
      dataField: "endDate",
      text: "End Date",
      sort: false,
      width: 140,
      show: true,
      inputType: "date",
      hideColFilter: true,
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
    },
    
  ]
  return (
    <>
      <div>
        <div
          className="table-card scroll-table position-relative border-0 rounded pt-0"
          fixed-height={resultData.length > 0 ? "fixed-height" : "default"}
        >
          <h4 className="f-15 text-primary font-weight-700"> Flat Dispensing Fee </h4>
          <ReactStrapTable
            id="dispFee-table"
            height={550}
            width={1200}
            data={resultData}
            columns={mainCol}
          />
        </div>
        <div
          className="table-card scroll-table position-relative border-0 rounded pt-0 mt-5"
          fixed-height={tableData.length > 0 ? "fixed-height" : "default"}
        >
          <h4 className="f-15 text-primary font-weight-700">
            Custom Dispensing Fee
          </h4>
          <ReactStrapTable
            id="dispFee-table-1"
            height={550}
            fixedColumn
            width={1200}
            data={tableData}
            columns={maincol1}
          />
        </div>
      </div>
    </>

  );
};
export default DispenseFees;
